module.exports = __webpack_public_path__ + "img/zoom.ee129d9d.svg";